import React from 'react';

interface SecurityLockIconProps {
  size?: number;
  color?: string;
}

/**
 * SecurityLockIcon Component
 * @description A security lock icon for SSL/certificate status
 */
export const SecurityLockIcon: React.FC<SecurityLockIconProps> = ({ 
  size = 32, 
  color = '#ec221f' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 32 32"
    >
      <path 
        fill={color} 
        d="M8.5 29a2.42 2.42 0 0 1-1.765-.727A2.38 2.38 0 0 1 6 26.523v-12.38q0-1.022.735-1.748a2.42 2.42 0 0 1 1.765-.728h1.25V9.19q0-2.568 1.829-4.379T16 3t4.422 1.811q1.83 1.813 1.828 4.38v2.476h1.25a2.42 2.42 0 0 1 1.766.728q.735.728.734 1.748v12.38q0 1.023-.734 1.75A2.41 2.41 0 0 1 23.5 29zm7.5-6.19q1.032 0 1.766-.727.735-.727.734-1.75 0-1.022-.734-1.748A2.43 2.43 0 0 0 16 17.857a2.4 2.4 0 0 0-1.765.728 2.4 2.4 0 0 0-.735 1.748 2.36 2.36 0 0 0 .735 1.75q.738.732 1.765.727m-3.75-11.143h7.5V9.19q0-1.547-1.094-2.63Q17.563 5.476 16 5.476T13.344 6.56q-1.095 1.083-1.094 2.63z"
      />
    </svg>
  );
};

export default SecurityLockIcon;

